import { FormInput } from 'components/molecules';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { booleanSelectOptions } from 'utils/components/inputs/select';
import './DigitalDeliveryBottomBar.scss';

interface IDigitalDeliveryBottomBarProps {
  showTimestamp?: boolean;
  timestampContent?: ReactNode;
  showReconnection?: boolean;
  showYtContentMatchPolicy?: boolean;
  ytContentMatchPolicyOptions?: { label: string; value: number }[];
  showManualStatus?: boolean;
  statusOptions: { label: string; value: number }[];
  isDeliveryCanceled?: boolean;
  isDeliveryWithdrawn?: boolean;
}

const DigitalDeliveryBottomBar = ({
  showTimestamp,
  timestampContent,
  showReconnection,
  showYtContentMatchPolicy,
  ytContentMatchPolicyOptions,
  showManualStatus,
  statusOptions,
  isDeliveryCanceled,
  isDeliveryWithdrawn,
}: IDigitalDeliveryBottomBarProps) => {
  const { t } = useTranslation();

  if (isDeliveryCanceled || isDeliveryWithdrawn) {
    return null;
  }

  const hasContent =
    showTimestamp ||
    showReconnection ||
    showYtContentMatchPolicy ||
    showManualStatus;

  if (!hasContent) {
    return null;
  }

  return (
    <div className='digital-delivery-bottom-bar'>
      {showTimestamp && timestampContent}
      {showReconnection && (
        <div className='digital-delivery-bottom-bar__field'>
          <FormInput.Select
            name='delivery.isReconnection'
            label={t('music-product-digital.delivery.is-reconnection')}
            options={booleanSelectOptions}
            displayMode={false}
          />
        </div>
      )}
      {showYtContentMatchPolicy && ytContentMatchPolicyOptions && (
        <div className='digital-delivery-bottom-bar__field'>
          <FormInput.Select
            name='delivery.ytContentMatchPolicy'
            label={t('music-product-digital.delivery.yt-content-match-policy')}
            options={ytContentMatchPolicyOptions}
            displayMode={false}
          />
        </div>
      )}
      {showManualStatus && (
        <div className='digital-delivery-bottom-bar__field'>
          <FormInput.Select
            name='delivery.status'
            label={t('input.label.status')}
            options={statusOptions}
            displayMode={false}
          />
        </div>
      )}
    </div>
  );
};

export default DigitalDeliveryBottomBar;

export const isDeliveryWithdrawnStatus = (status?: DELIVERY_STATUS) =>
  status === DELIVERY_STATUS.withdrawInProgress ||
  status === DELIVERY_STATUS.withdrawn ||
  status === DELIVERY_STATUS.withdrawError ||
  status === DELIVERY_STATUS.withdrawWaiting;
